module.exports = __webpack_public_path__ + "static/media/nina-win.4852ae07.png";